module.exports = __webpack_public_path__ + "static/fonts/customFont.801a341a.ttf";